import React from "react";

const HeroPage: React.FC<{
  header: string;
  subHeader: string;
  children?: React.ReactNode;
  max?: number;
}> = ({ subHeader, header, children, max }) => {
  return (
    <div className="py-[7rem] bg-cover bg-[linear-gradient(90deg,rgba(var(--primary-color-rgb),1)_0%,rgba(var(--primary-color-rgb),0.3)_100%),url('/images/hero-bg.webp')]">
      <div className="wrapper text-white  flex md:flex-col justify-between">
        <div className="first basis-1/2">
          <div className="font-semibold relative pb-5">
            <h1>{header}</h1>
            <Underline />
          </div>
          <h2
            style={{
              maxWidth: max,
            }}
            className="max-w-[600px] h5"
          >
            {subHeader}
          </h2>
        </div>
        {children && <div className="second basis-1/2">{children}</div>}
      </div>
    </div>
  );
};
export default HeroPage;

const Underline = () => {
  return (
    <span className="block w-[600px]">
      <svg
        width="100%"
        height="2"
        viewBox="0 0 100% 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L701 1"
          stroke="url(#paint0_linear_631_45952)"
          stroke-linecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_631_45952"
            x1="1"
            y1="2"
            x2="424.063"
            y2="1.61719"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.901596" stop-color="white" stop-opacity="0.1" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  );
};
